<div id="head_wrap">
  <div id="closeBtn">
    <span  (click)="close();">×</span>
  </div>
  <h1 id="title" class="fontSize24">能力考核</h1>
</div>

<img src="../../assets/picture/hrreport/success.png" alt="" id="graduatedPic" *ngIf="level>=5">

<div id="graduatedText" class="fontSize18 lineHeight32" *ngIf="level>=5">
  恭喜你，<br/>
  获得能力考核&nbsp;&nbsp;<span class="textLevel fontSize36"><i>L{{level}}</i></span>&nbsp;&nbsp;级别，<br/>
  顺利毕业啦！
</div>

<img src="../../assets/picture/hrreport/fail.png" alt="" id="failedPic" *ngIf="level<5">

<div id="failedText" class="fontSize18 lineHeight32" *ngIf="level<5">
  好可惜，<br/>
  能力考核只有&nbsp;&nbsp;<span class="textLevel fontSize36"><i>L{{level}}</i></span>&nbsp;&nbsp;级别，<br/>
  来查看你的详细报告吧！
</div>

<div id="closeBtn2" class="fontSize18 closeBtnBorder" (click)="close();">关闭本页面</div>




// WEBPACK FOOTER //
// ./src/app/post-ability-test-tip/post-ability-test-tip.component.html